import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Box, Typography } from '@mui/material';
import { FONT_HEADING } from '../../theme/theme';
function titleCaseWord(s) {
    const t = s.trim();
    if (!t)
        return '';
    return t.charAt(0).toUpperCase() + t.slice(1).toLowerCase();
}
function titleCasePhrase(raw) {
    const t = raw.trim().replace(/\s+/g, ' ');
    if (!t)
        return 'West Virginia';
    return t
        .split(' ')
        .map((w) => titleCaseWord(w))
        .join(' ');
}
/**
 * Two-line “West” / “Virginia” for the seal lockup (Baskerville Medium in parent styles).
 */
export function splitStateWordmark(raw) {
    const t = raw.trim().replace(/\s+/g, ' ');
    if (!t)
        return ['West', 'Virginia'];
    const i = t.indexOf(' ');
    if (i === -1)
        return [titleCaseWord(t), ''];
    return [titleCaseWord(t.slice(0, i)), titleCaseWord(t.slice(i + 1).trim())];
}
const WORDMARK_SIZES = {
    /** Footer / compact rails */
    default: {
        fontSize: { xs: '0.8125rem', sm: '0.875rem', md: '0.95rem' },
        letterSpacing: '0.04em',
    },
    /** Nav bar — larger than center links so seal + title lead the hierarchy */
    navbar: {
        fontSize: { xs: '0.95rem', sm: '1.0625rem', md: '1.125rem' },
        letterSpacing: '0.045em',
    },
};
/**
 * Stacked state name beside the WV seal — Baskerville Medium (nav + footer).
 */
export const WvStackedStateWordmark = ({ text = 'West Virginia', color = '#ffffff', size = 'default', singleLine = false }) => {
    const [line1, line2] = splitStateWordmark(text);
    const oneLineText = titleCasePhrase(text);
    const isNavbar = size === 'navbar' || singleLine;
    const token = WORDMARK_SIZES[size];
    const lineSx = {
        fontFamily: FONT_HEADING,
        fontWeight: 500,
        color,
        lineHeight: 1.12,
        fontSize: token.fontSize,
        letterSpacing: token.letterSpacing,
        display: 'block',
        whiteSpace: isNavbar ? 'nowrap' : 'normal',
        m: 0,
        p: 0,
    };
    if (isNavbar) {
        return (_jsx(Box, { sx: { display: 'flex', alignItems: 'center', m: 0, minWidth: 0 }, children: _jsx(Typography, { component: "span", sx: lineSx, children: oneLineText }) }));
    }
    return (_jsxs(Box, { sx: { display: 'flex', flexDirection: 'column', justifyContent: 'center', m: 0 }, children: [_jsx(Typography, { component: "span", sx: lineSx, children: line1 }), line2 ? (_jsx(Typography, { component: "span", sx: lineSx, children: line2 })) : null] }));
};
